import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateUtils } from '../../../utils/date.utils';

export const maxDate = (dateString: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    return DateUtils.isAfter(control.value, dateString) ? { maxdate: 'Date après date limite' } : null;
  }
}
